export default {
  title: 'Brugerdefinerede trykprodukter',
  fields: {
    name: 'Navn',
    format: 'Produkttype',
  },
  buttons: {
    upload_product: 'Start uploadprocessen',
    preview: 'Forhåndsvisning',
    edit: 'Rediger',
  },
};
